import { API_URL, APP_VERSION } from '../api/config';

/**
 * Crash reporting without a third-party SDK: fatal errors post to the API's
 * /app/crash intake (same pipe as mobile), which logs, persists for the
 * admin Errors page, and pages ops on hard crashes. Fire-and-forget plain
 * fetch — the app may be mid-crash, so nothing here imports the typed
 * client or any store.
 */
let lastSentAt = 0;

export function reportCrash(level: 'crash' | 'error', message: string, stack?: string): void {
  const now = Date.now();
  if (now - lastSentAt < 30_000) return; // a crash loop must not DDoS ourselves
  lastSentAt = now;
  try {
    void fetch(`${API_URL}/app/crash`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        message: String(message).slice(0, 2000),
        stack: stack?.slice(0, 8000),
        platform: 'web',
        version: APP_VERSION,
        source: 'web',
        level,
        context: { route: window.location.pathname, ua: navigator.userAgent.slice(0, 200) },
      }),
    }).catch(() => undefined);
  } catch {
    // even queueing failed — nothing left to do
  }
}

export function installCrashReporter(): void {
  window.addEventListener('error', (e) => {
    // Resource-load failures (blocked scripts, dead images) arrive here too,
    // but without an Error they're noise, not crashes.
    if (!(e.error instanceof Error)) return;
    reportCrash('crash', e.error.message, e.error.stack);
  });
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    const err = r instanceof Error ? r : new Error(String(r));
    reportCrash('error', err.message, err.stack);
  });
}
